var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { LinkText } from 'ilenia';
import { Box } from '../Layout';
export var NotificationBox = function (props) {
    var text = props.text, links = props.links;
    return (React.createElement(Box, { className: css(styles.errorBox) },
        React.createElement(LinkText, { id: text, links: links ? __spreadArrays(links) : [] })));
};
var styles = StyleSheet.create({
    errorBox: {
        fontSize: '14px',
        marginBottom: '16px',
        backgroundColor: 'rgba(252, 76, 93, 0.15)',
        color: 'rgb(197, 63, 76)',
        borderRadius: '3px',
        padding: '16px',
    },
});
